import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ConfirmOverlayComponent } from 'src/app/elements/confirm-overlay/confirm-overlay.component';
import { DonationEntry } from 'src/app/models/donation-entry-list.interface';
import { DonationPaymentStatus, DonationType } from 'src/app/models/donation.interface';

@Component({
    selector: 'app-donation-row',
    templateUrl: './donation-row.component.html',
    styleUrls: ['./donation-row.component.scss'],
})
export class DonationRowComponent {
    @Input() donation!: DonationEntry;
    @Input() hiddenFilters: string[] = [];
    @Input() spans!: number[];
    @Input() visibleSpans!: number;

    @Output() delete = new EventEmitter<void>();

    donationPaymentStatus = DonationPaymentStatus;
    donationType = DonationType;

    constructor(private readonly router: Router, private readonly dialog: MatDialog) {}

    navigate(): void {
        if (this.donation.hasDonator && this.donation.donatorId) {
            this.router.navigate(['/spender/' + this.donation.donatorId], {
                queryParams: { donation: this.donation._id },
            });
        } else {
            this.router.navigate(['/manual-assign'], { queryParams: { donation: this.donation._id } });
        }
    }

    deleteDonation(): void {
        const dialog = this.dialog.open(ConfirmOverlayComponent, {
            data: {
                lockedBackgroundColor: '#ff3838',
                unlockedBackgroundColor: '#5ebd3e',
                headline: 'Der Geldeingang ist keine Spende?',
                content:
                    'Wenn Sie die Spende löschen, gehen Ihre Daten verloren und können nicht wiederhergestellt werden.',
                confirmText: 'Löschen',
            },
            maxWidth: '100vw',
            height: '100vh',
            panelClass: 'confirm-overlay',
        });
        dialog.afterClosed().subscribe((res) => {
            if (res) {
                this.delete.emit();
            }
        });
    }
}
